import React, { Component } from "react";

import AboutPicture from "../assets/AboutPicture.svg";
import ScrollAnimation from "react-animate-on-scroll";

import { FaHtml5, FaCss3Alt, FaReact } from "react-icons/fa";
import AdobeXD from "../assets/AdobeXD.svg";

import ScrollDownRed from "../assets/ScrollDownRed.svg";

import { Element, scroller } from "react-scroll";

export default class About extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  scrollToPage2 = () => {
    scroller.scrollTo("page2", {
      duration: 600,
      delay: 100,
      smooth: true,
    });
  };

  render() {
    return (
      <div className="about">
        <div className="page-1">
          {this.state.width > 1560 ? (
            <div className="page-1-container wrapper">
              <div className="page-1-image-container">
                <ScrollAnimation animateIn="animateIn">
                  <img src={AboutPicture} alt="" className="page-1-image svg" />
                </ScrollAnimation>
              </div>
              <div className="page-1-info">
                <div className="page-1-info-left">
                  <div className="title">Jordan Harris</div>
                  <div className="sub-text">
                    I am a freelance{" "}
                    <span className="semi-bold">web developer</span> and{" "}
                    <span className="semi-bold">designer</span>. My goal is to
                    provide customers with personalized web pages and designs to
                    better represent their brands and attract more clients.{" "}
                  </div>
                </div>
                <ScrollAnimation animateIn="animateInDivider">
                  <div className="divider"></div>
                </ScrollAnimation>
                <div className="page-1-info-right">
                  <div className="title">Education</div>
                  <div className="sub-text">
                    <span className="semi-bold">
                      Bachelors of Science: Computer Science
                    </span>
                    <br />
                    California State Polytechnic University, Pomona
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="page-1-container wrapper">
              <div className="page-1-image-container">
                <ScrollAnimation animateIn="animateIn">
                  <img src={AboutPicture} alt="" className="page-1-image svg" />
                </ScrollAnimation>
              </div>
              <div className="page-1-info-container">
                <div className="page-1-info-left">
                  <div className="title">Jordan Harris</div>
                  <div className="sub-text">
                    I am a freelance{" "}
                    <span className="semi-bold">web developer</span> and{" "}
                    <span className="semi-bold">designer</span>. My goal is to
                    provide customers with personalized web pages and designs to
                    better represent their brands and attract more clients.{" "}
                  </div>
                </div>
                <div className="page-1-info-right"></div>
                <div className="title">Education</div>
                <div className="sub-text">
                  <span className="semi-bold">
                    Bachelors of Science: Computer Science
                  </span>
                  <br />
                  California State Polytechnic University, Pomona
                </div>
              </div>
            </div>
          )}
          <div onClick={this.scrollToPage2} className="scroll-down-container">
            <img src={ScrollDownRed} alt="" className="scroll-down" />
          </div>
        </div>
        <Element name="page2">
          <div className="page-2">
            <div className="wrapper page-2-skills-container">
              <div className="title">Technical Skills</div>
              <div className="page-2-grid">
                <div className="page-2-grid-item">
                  <div className="inner-grid-item">
                    <FaHtml5 className="page-2-icon"></FaHtml5>
                    <div className="semi-bold sub-text skill-label">HTML 5</div>
                  </div>
                </div>
                <div className="page-2-grid-item">
                  <div className="inner-grid-item">
                    <FaCss3Alt className="page-2-icon"></FaCss3Alt>
                    <div className="semi-bold sub-text skill-label">CSS 3</div>
                  </div>
                </div>
                <div className="page-2-grid-item">
                  <div className="inner-grid-item">
                    <FaReact className="page-2-icon"></FaReact>
                    <div className="semi-bold sub-text skill-label">
                      REACT.JS
                    </div>
                  </div>
                </div>
                <div className="page-2-grid-item">
                  <div className="inner-grid-item">
                    <div className="page-2-adobe-container">
                      <img src={AdobeXD} alt="" className="page-2-adobe" />
                    </div>
                    <div className="semi-bold sub-text skill-label">
                      ADOBE XD
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Element>
      </div>
    );
  }
}
